module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "magazine-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Magazine List')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Magazine List')))]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        _vm.goMagazineNew()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('New Registration')))])])])]), _c('div', [((_vm.magazines != null && _vm.magazines.length > 0) && _vm.searchCallbackFlag) ? _c('div', [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.magazines), function(magazine, index) {
    return _c('tr', [_c('td', [(magazine.attributes['magazine-picture-path']) ? _c('p', {
      staticClass: "img-area-list"
    }, [_c('img', {
      attrs: {
        "src": magazine.attributes['magazine-picture-path'] + '?token=' + _vm.authToken + '&timestamp=' + _vm.timeStamp
      },
      on: {
        "click": function($event) {
          _vm.onClickImageModalShow(magazine)
        }
      }
    })]) : _vm._e()]), _c('td', [_c('a', {
      attrs: {
        "href": _vm.goMagazinePdf(magazine.attributes['magazine-pdf-path']),
        "type": "application/pdf",
        "target": "_blank"
      }
    }, [_vm._v(" " + _vm._s(magazine.attributes['magazine-title']))])]), _c('td', [_vm._v(_vm._s(magazine.attributes['magazine-ym-format']))]), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_c('a', {
      staticClass: "btn btn-info btn-sm margin-right",
      on: {
        "click": function($event) {
          _vm.goMagazineEdit(magazine.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Edit')))]), _c('a', {
      staticClass: "btn btn-danger btn-sm",
      on: {
        "click": function($event) {
          _vm.magazineDelete(magazine.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('Delete')))])])])
  }))])])]), (_vm.nextPage) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-default next-page-search-btn",
    on: {
      "click": function($event) {
        _vm.search(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('Read More')))])])])]) : _vm._e()]) : _vm._e(), ((_vm.magazines == null || _vm.magazines.length <= 0) && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()]), (_vm.savingFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_vm._m(1)]) : _vm._e(), _c('button', {
    staticClass: "hide",
    attrs: {
      "id": "imageModalButton",
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#imageModal"
    }
  }, [_vm._v("モーダル発火用")]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "imageModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modalcenter"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _c('div', {
    staticClass: "modal-img_footer text-center"
  }, [_c('p', {
    attrs: {
      "id": "imageModalText"
    }
  }), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t('Close')))])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-2"
  }, [_vm._v("サムネイル")]), _c('th', {
    staticClass: "col-sm-6"
  }, [_vm._v("タイトル")]), _c('th', {
    staticClass: "col-sm-4",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("年月")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/loading.gif")
    }
  }), _c('p', [_vm._v("loading...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    staticClass: "img-responsive center-block",
    attrs: {
      "id": "imageModalImg",
      "src": "",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-248c1c28!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/magazine-list.pug
// module id = 786
// module chunks = 1